import { publicRuntimeConfig } from "./public-runtime-config";

/*
 * Per-deployment defaults supplied by the server-rendered runtime bootstrap.
 * Clerk-backed organization icon settings override these defaults once an
 * administrator saves them from the organization management page.
 */
export function orgAvatarColors(): { background: string; text: string } | null {
  const config = publicRuntimeConfig();
  const background = config.orgAvatarBackgroundColor;
  if (!background) return null;
  const text = config.orgAvatarTextColor || "#ffffff";
  return { background, text };
}
